module.exports = __webpack_public_path__ + "static/media/money.5ab8ac34.svg";